import { css, Interpolation } from 'styled-components';

const breakpoints = {
  lg: '992px',
  md: '768px',
  sm: '576px',
  xl: '1200px',
  xs: '0px',
};

const md = 768;
const xl = 1200;

export const mobileQuery = `(max-width: ${breakpoints.sm})`;
export const mdQuery = `(max-width: ${breakpoints.md})`;
export const gtMdQuery = `(min-width: ${breakpoints.md})`;
export const ltLgQuery = `(max-width: ${breakpoints.lg})`;
export const largeQuery = `(min-width: ${xl + 200}px)`;
export { md };

export enum Breakpoints {
  THOUSAND = 1000,
}

type MediaQueryProxy<T extends object = any> = (content: Interpolation<T>) => Interpolation<T>;
type ScreenMediaQuery = MediaQueryProxy & { below: MediaQueryProxy };

function createScreenMediaQuery(breakpoint: Breakpoints): ScreenMediaQuery {
  const exactAndAbove = (content: Interpolation<any>) => css`
    @media screen and (min-width: ${breakpoint}px) {
      ${content};
    }
  `;

  exactAndAbove.below = (content: Interpolation<any>) => css`
    @media screen and (max-width: ${breakpoint}px) {
      ${content};
    }
  `;

  return exactAndAbove;
}

export const desktopQuery = createScreenMediaQuery(Breakpoints.THOUSAND);
